export const GET_ENCRYPTED_PSEUDONYMS_REQUEST = 'GET_ENCRYPTED_PSEUDONYMS_REQUEST';

export const getEncryptedPseudonymsRequest = () => ({
    type: GET_ENCRYPTED_PSEUDONYMS_REQUEST,
});
